<ng-container *ngIf="store.selectedProject.projection">
  <div class="map-wrapper">
    <div id="map" class="map" [class.full-page]="fullPage">
      <mat-icon *ngIf="enableGeolocation" class="material-icons-outlined btn-map btn-location"
                (click)="handleGeolocation(true)">my_location
      </mat-icon>
    </div>
    <span *ngIf="showError" class="fake-error">{{ 'FIELD_ERROR.GEOLOCATION' | translate }}</span>
  </div>
</ng-container>

